import { render, staticRenderFns } from "./currentWidgets.vue?vue&type=template&id=6dd5e8a0&scoped=true&"
import script from "./currentWidgets.vue?vue&type=script&lang=js&"
export * from "./currentWidgets.vue?vue&type=script&lang=js&"
import style0 from "./currentWidgets.vue?vue&type=style&index=0&id=6dd5e8a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd5e8a0",
  null
  
)

export default component.exports